import { useNavigate } from "react-router-dom";

import SharedEmptyState from "../../components/EmptyState";
import emptyStateImage from "../../assets/images/competitions-empty-state.svg";
import { DASHBOARD_STACK } from "../../utils/screenNames";

const CompetitionsEmptyState = () => {
  const navigate = useNavigate();

  return (
    <div className="h-full bg-[#000F1F] flex flex-col">
      <SharedEmptyState
        className="!justify-center"
        illustration={emptyStateImage}
        illustrationClassName="w-[600px]"
        heading="Ready to launch your first competition?"
        description="Start by pressing the button below"
        actions={
          <div className="flex justify-center w-full">
            <button
              onClick={() => navigate(DASHBOARD_STACK.COMPETITIONS)}
              className="px-20 h-11 bg-[#00E7FF] text-[#021529] rounded-full font-medium text-[15px] hover:opacity-50 transition-opacity"
            >
              Create competition
            </button>
          </div>
        }
      />
    </div>
  );
};

export default CompetitionsEmptyState;
